import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import './assets/style/theme/index.css'
import i18n from './i18n'
import feather from 'vue-icon';
import Auth from '@aws-amplify/auth';
import axios from 'axios';

import {
  Login, ChangeTmpPassword, ResetPassword, SelectEnterprise,
} from '@bag-era/cognito-authentication';

Vue.use(ElementUI, { locale })
Vue.config.productionTip = false

// eslint-disable-next-line prefer-destructuring
const enterprise = store.getters.enterprise;
console.log("configure", enterprise)
if (enterprise) {
  const awsExports = {
    aws_project_region: enterprise.poolInfo.region,
    aws_cognito_region: enterprise.poolInfo.region,
    aws_user_pools_id: enterprise.poolInfo.userPoolId,
    aws_user_pools_web_client_id: enterprise.poolInfo.clientId,
  };
  console.log("configure", awsExports)
  Auth.configure(awsExports);
}
// Add latest auth access token to every http request
axios.interceptors.request.use((config) => {
  if (store.getters.enterprise) {
    return Auth.currentSession()
      .then((session) => {
        // User is logged in. Set auth header on all requests
        // eslint-disable-next-line no-param-reassign
        config.headers.Authorization = "Bearer " + session.idToken.jwtToken;
        return Promise.resolve(config);
      })
      .catch(() => {
        // No logged-in user: don't set auth header - got to login page
          store.dispatch('setUser', null);
          router.push('/auth');
      });
  }
  return Promise.resolve(config);
});


//--------------------------------------------------
//                    FILTERS                     //
//--------------------------------------------------

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('upper', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.toUpperCase();
})

Vue.use(Login, ChangeTmpPassword, ResetPassword, SelectEnterprise);
Vue.use(feather, 'v-icon');
Vue.use(Auth);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
